import SpintrSocialFeed from "./SpintrSocialFeed";

export { SpintrSocialFeed };
